module.exports = __webpack_public_path__ + "static/haleo-logo-fr-0ec5f2d8c5978d8df8e220ff4dbcc20c.jpg";